import React from 'react';
import { Affix, Avatar, Input, List } from 'antd';
import { connect } from 'react-redux';
import banner from '../assets/images/image_banner.png';
import detailBtn from '../assets/images/icon_detail.png';
import icon1 from '../assets/images/icon_1st.png';
import icon2 from '../assets/images/icon_2nd.png';
import icon3 from '../assets/images/icon_3rd.png';
import * as R from 'ramda';
import FuzzySearch from 'fuzzy-search';
import { BenqDataSet } from '../constant/benqData';

const { Search } = Input;

class BenqBoard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            result: [],
        };

        this.handleOnSubmit = this.handleOnSubmit.bind(this);
        this.getAvatar = this.getAvatar.bind(this);
    }

    handleOnSubmit(value) {
        const searcher = new FuzzySearch(BenqDataSet, ['team'], {
            caseSensitive: false,
        });
        const target = searcher.search(value);
        this.setState({
            result: R.isEmpty(target) ? [] : target,
        });
    }

    getAvatar(index) {
        switch (index) {
            case 1:
                return <Avatar src={icon1} size='large' />

            case 2:
                return <Avatar src={icon2} size='large' />

            case 3:
                return <Avatar src={icon3} size='large' />

            default:
                return <Avatar style={{ backgroundColor: 'black', verticalAlign: 'middle'}} size='large'>{index}</Avatar>
        }
    }

    componentDidUpdate(prevProps) {

    }

    render() {
        const { result } = this.state;
        var sortedDatas = BenqDataSet;
        sortedDatas.sort((a, b) => {
            if (a.total < b.total) return 1;
            if (a.total > b.total) return -1;
            if (a.weight < (b.weight || 0)) return 1;
            if (a.weight > (b.weight || 0)) return -1;
            return 0;
        });
        const small = window.innerWidth < 430;
        return (
            <div>
                <div style={{ textAlign: 'center', backgroundColor: '#7CC0CC' }}>
                    <Affix offsetTop>
                        <div style={{ background: '#7CC0CC' }}>
                            <img src={banner} alt="fitCloud" style={{ width: '100%', marginBottom: '30px' }} />
                            <span>
                                {small ? null :
                                    <a href='https://campaign.fitgames.tw/benq'>
                                        <img src={detailBtn} alt="detail" style={{ width: '130px', marginRight: '10px'}} />
                                    </a>}
                                <Search
                                    placeholder="輸入隊伍名稱"
                                    onSearch={this.handleOnSubmit}
                                    size='large'
                                    enterButton='搜尋'
                                    allowClear
                                    style={{ width: `${small ? '90vw' : '70vw'}`}}
                                />
                            </span>
                            {small ? 
                                <a href='https://campaign.fitgames.tw/benq'>
                                    <img src={detailBtn} alt="detail" style={{ width: '130px', marginTop: '10px'}} />
                                </a> : null}
                        </div>
                        <p style={{ background: '#7CC0CC' }}>更新時間: 2021/04/12 11:00</p>
                    </Affix>
                    <List
                        itemLayout='horizontal'
                        dataSource={R.isEmpty(result) ? sortedDatas : result}
                        bordered
                        renderItem={item => (
                            <List.Item style={{ textAlign: 'left' }}>
                                <List.Item.Meta
                                avatar={this.getAvatar(1 + sortedDatas.indexOf(item))}
                                title={`${item.team} :: ${item.total} 天`}
                                description={item.members.reduce((prev, current) => {
                                    return `${prev} | ${current.name} ${current.score}天`;
                                }, '')}
                                />
                            </List.Item>)
                        }
                        style={{ marginTop: 30 }}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BenqBoard);
